module.exports = __webpack_public_path__ + "media/public/img/logo-bird-26c7a08db156dca59a685ef44a8ee973.png";